/** @format */

const $utils = {
	toBoolean(obj, defaultValue = false) {
		if ($utils.isEmpty(obj)) {
			return defaultValue;
		}
		return $utils.oneOf(obj, [true, 'True', 'Yes', 'true', '1', 1, 'yes', 'Y', 'y', 'T', 't']);
	},
	isEmpty(obj, allowBlank = false) {
		if ($utils.isNull(obj)) return true;
		if ($utils.isArray(obj)) return obj.length === 0;
		if ($utils.isString(obj)) return !(allowBlank || obj.length > 0);
		if ($utils.isObject(obj)) return $utils.isEmptyObject(obj);
		for (const key in obj) if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
		return obj === undefined || (!allowBlank ? obj === '' : false);
	},
	oneOf(value, validList) {
		for (let i = 0; i < validList.length; i++) {
			if (value === validList[i]) {
				return true;
			}
		}
		return false;
	},
	isNull(input) {
		return input === undefined || input === null;
	},
	isArray(input) {
		return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	},
	isString(input) {
		return input instanceof String || Object.prototype.toString.call(input) === '[object String]';
	},
	isObject(input) {
		return Object.prototype.toString.call(input) === '[object Object]';
	},
	isEmptyObject(obj) {
		if (!obj) return true;
		if (Object.keys(obj).length !== 0) {
			return false;
		}
		return true;
	},
	// 过滤公共方法
	optionsFilter(val, options = [], labelKey = 'label', valueKey = 'value', defaultValue = '') {
		let opt;
		if (Array.isArray(options)) {
			opt = options.find((x) => x[valueKey] === val);
		}
		return opt ? opt[labelKey] : val || defaultValue;
	},
	isNotEmpty(obj, allowBlank = false) {
		return !$utils.isEmpty(obj, allowBlank);
	},
	isNumber(input) {
		return input instanceof Number || Object.prototype.toString.call(input) === '[object Number]';
	},
	textLength(text = '') {
		return text.split('').reduce((pre, cur) => {
			const charCode = cur.charCodeAt(0);
			if (charCode >= 0 && charCode <= 128) {
				return pre + 1;
			}
			return pre + 2;
		}, 0);
	},
	formatSize(size, pointLength, units) {
		units = units || ['B', 'K', 'M', 'G', 'TB'];
		let unit;
		while ((unit = units.shift()) && size >= 1024) {
			size = size / 1024;
		}
		return (unit === 'B' ? size : size.toFixed(pointLength || 2)) + unit;
	},
	parseJSON(data, defaultValue) {
		if ($utils.isNotEmpty(data)) {
			return $utils.isJSON(data) ? JSON.parse(data) : data;
		} else {
			return defaultValue || data;
		}
	},
	isJSON(str) {
		if ($utils.isString(str)) {
			try {
				const obj = JSON.parse(str);
				return $utils.isPlainObject(obj) || $utils.isArray(obj);
			} catch (e) {
				return false;
			}
		}
		return false;
	},
	isPlainObject(obj) {
		if (
			obj &&
			Object.prototype.toString.call(obj) === '[object Object]' &&
			obj.constructor === Object &&
			!Object.prototype.hasOwnProperty.call(obj, 'constructor')
		) {
			let key;
			for (const k in obj) {
				key = k;
			}
			return key === undefined || Object.prototype.hasOwnProperty.call(obj, key);
		}
		return false;
	},
};

export { $utils };
